import React, { useRef, useState, useEffect } from "react";
import "./home.css";
import FAQ from "../../UI/faq/Faq";
import CompaniesLogo from "../../UI/Companies-Logo/CompaniesLogo";
import Testimonial from "../../UI/testimonial/Testimonial";
import Icon1 from "../../../assets/icons/icon7.gif";
import Icon2 from "../../../assets/icons/icon8.gif";
import Icon3 from "../../../assets/icons/icon9.gif";
import { useQuickAccess } from "../pages/QuickAccessContext";
import Arrow from "../../../assets/icons/arrow.gif"
import AuthModal from "./../Membership/AuthModal/AuthModal.jsx";
import AnimatedNumber from "../../UI/AnimatedCout/AnimatedNumber.jsx";

const videos = [
    {
        id: "LJplT_dAcy8",
        title: "IHN Outreach Event",
        description: "28 March 2025 | Hotel Le Meridien | New Delhi"
    },
    {
        id: "Nx-A3aYAsB4",
        title: "IHN Social Networking",
        description: "26 May 2023 | Qutub Golf Course - QGC | New Delhi"
    },
    {
        id: "VJVsDSw1Yfw",
        title: "IHN KONNECT 2022",
        description: "29th June 2022 | The Leela Ambience Convention Hotel | Delhi"
    },
    {
        id: "fPd8qBPAEz8",
        title: "IHN KONNECT 2.0 | Super 100 Awards",
        description: "4th October 2023 | The Leela Ambience Convention Hotel | Delhi"
    },
    {
        id: "E0yjTEXEp74",
        title: "IHN Network Multiplier",
        description: "5 December 2025 | Hotel Lyfe | Bhubaneshwar"
    },
    {
        id: "luH_Bm9qDno",
        title: "IHN Socials",
        description: "8 April 2023 | Heritage Transport Museum | Gurgaon"
    },
    {
        id: "qwbDyzlvgeE",
        title: "IHN KONNECT 2.0 Day 2",
        description: "5th October 2023 | The Leela Ambience Convention Hotel | Delhi"
    },
    {
        id: "NrUijib5Iak",
        title: "Flagship Annual Event",
        description: "5th October 2023 | The Leela Ambience Convention Hotel | Delhi"
    }
];

function Home() {
    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * videos.length);
        setCurrentIndex(randomIndex);
    }, []);
    const iframeRef = useRef(null);

    const [showAuth, setShowAuth] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [isMuted, setIsMuted] = useState(true); // Default to muted for autoplay compliance

    const nextSlide = () => {
        setCurrentIndex((prev) => (prev === videos.length - 1 ? 0 : prev + 1));
    };

    const prevSlide = () => {
        setCurrentIndex((prev) => (prev === 0 ? videos.length - 1 : prev - 1));
    };
    const toggleMute = () => {
        setIsMuted(prev => !prev);
    };

    useEffect(() => {
        const iframe = iframeRef.current;
        if (!iframe) return;

        const command = isMuted ? "mute" : "unMute";

        // Small delay to ensure iframe is ready
        const timer = setTimeout(() => {
            iframe.contentWindow.postMessage(
                JSON.stringify({
                    event: "command",
                    func: command,
                    args: []
                }),
                "*"
            );
        }, 500);

        return () => clearTimeout(timer);
    }, [currentIndex, isMuted]);

    return (

        <div className="home-wrapper" style={{ paddingTop: "0px" }}>

            {/* HERO SECTION */}
            <section className="hero-viewport">
                <div className="video-background-container">
                    {currentIndex !== null && (
                        <iframe
                            ref={iframeRef}
                            key={videos[currentIndex].id}
                            src={`https://www.youtube.com/embed/${videos[currentIndex].id}?autoplay=1&mute=1&loop=1&playlist=${videos[currentIndex].id}&controls=0&modestbranding=1&rel=0&enablejsapi=1`}
                            frameBorder="0"
                            allow="autoplay; encrypted-media"
                            className="full-bg-video"
                            title="Background Video"
                        />
                    )}
                </div>

                {/* EYE-CATCHING MUTE CONTROL */}
                <button className="mute-control-btn" onClick={toggleMute}>
                    <span className="mute-icon">{isMuted ? "🔇" : "🔊"}</span>
                    <span className="mute-text">{isMuted ? "Unmute" : "Mute"}</span>
                    <div className="pulse-ring"></div>
                </button>

                <div className="hero-overlay-content">
                    <div className="text-card-bottom">

                        {currentIndex !== null && videos[currentIndex] && (
                            <h2 className="fade-in-line" key={`content-${currentIndex}`}>
                                <span className="hero-title-tag">
                                    {videos[currentIndex].title}:
                                </span>
                                <span className="hero-desc-tag">
                                    {videos[currentIndex].description}
                                </span>
                            </h2>
                        )}

                    </div>
                </div>

                <button className="nav-btn left text-light" onClick={prevSlide}>
                    ❮ 
                </button>
                <button className="nav-btn right text-light" onClick={nextSlide}>
                    ❯
                </button>

                <div className="indicators">
                    {videos.map((_, i) => (
                        <div
                            key={i}
                            className={`dot ${i === currentIndex ? 'active' : ''}`}
                            onClick={() => setCurrentIndex(i)}
                        />
                    ))}
                </div>
            </section>

            {/* ABOUT SECTION */}
            <section className="about-section py-5">
                <div className="container about-container">
                    <div className="row align-items-center gap-5">

                        <div className="about-text">
                            <h1 className="heading text-center">About IHN</h1>
                            <p className="about-lead">IHN is a premier, curated membership ecosystem and concierge service designed to unite elite professionals across the Hospitality, Travel, Events, and allied sectors. By facilitating strategic #DreamConnects and high-impact synergies, we empower our members to transcend traditional networking, fostering meaningful collaborations that drive global credibility and domestic growth.</p>

                            <div className="row g-4 justify-content-center">

                                <div className="col-md-4">

                                    <div className="network-stat-card">

                                        <img src={Icon1} alt="Exhibitors" className="network-icon" />

                                        <h4 style={{ color: "#861b68" }}><AnimatedNumber value={75}/>+ Unique Exhibitors</h4>

                                        <p style={{ color: "#861b68" }}>Leading brands & decision-makers across hospitality and tourism</p>

                                    </div>

                                </div>
                                <div className="col-md-4">

                                    <div className="network-stat-card">

                                        <img src={Icon2} alt="Buyers" className="network-icon" />

                                        <h4 style={{ color: "#861b68" }}><AnimatedNumber value={3500}/>+ Hosted Buyers</h4>

                                        <p style={{ color: "#861b68" }}>Qualified buyers enabling focused B2B conversations</p>

                                    </div>

                                </div>
                                <div className="col-md-4">

                                    <div className="network-stat-card">

                                        <img src={Icon3} alt="Meetings" className="network-icon" />

                                        <h4 style={{ color: "#861b68" }}><AnimatedNumber value={50000}/>+ Meetings</h4>

                                        <p style={{ color: "#861b68" }}>High-value meetings driving measurable business growth</p>

                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                    <button
                        className="join-now mt-5"
                        onClick={() => setShowAuth(true)}>

                        <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M5 13c0-5.088 2.903-9.436 7-11.182C16.097 3.564 19 7.912 19 13c0 .823-.076 1.626-.22 2.403l1.94 1.832a.5.5 0 0 1 .095.603l-2.495 4.575a.5.5 0 0 1-.793.114l-2.234-2.234a1 1 0 0 0-.707-.293H9.414a1 1 0 0 0-.707.293l-2.234 2.234a.5.5 0 0 1-.793-.114l-2.495-4.575a.5.5 0 0 1 .095-.603l1.94-1.832C5.077 14.626 5 13.823 5 13zm1.476 6.696l.817-.817A3 3 0 0 1 9.414 18h5.172a3 3 0 0 1 2.121.879l.817.817.982-1.8-1.1-1.04a2 2 0 0 1-.593-1.82c.124-.664.187-1.345.187-2.036 0-3.87-1.995-7.3-5-8.96C8.995 5.7 7 9.13 7 13c0 .691.063 1.372.187 2.037a2 2 0 0 1-.593 1.82l-1.1 1.039.982 1.8zM12 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" fill="currentColor"></path>
                        </svg>
                        <span className="text-light">Join Now</span>

                    </button>

                </div>

            </section>

            {/* BUILDING NETWORK SECTION */}
            <section className="building-network-section">
                <div className="container text-center">
                    <h1 className="heading text-light mb-3">
                        Building Platforms for Your Network Multiplication
                    </h1>
                    <p className=" text-light px-5 fs-4">
                        In a fast-changing business environment driven by evolving technologies,
                        new products, and emerging buyer segments, staying connected is no longer
                        optional — it is essential.
                        Global events and recent business realignments have reshaped the industry.
                        While some connections may fade, new opportunities continue to emerge
                        through fresh suppliers, buyers, and collaborations.
                    </p>

                </div>
            </section>

            <Testimonial />

            <FAQ />
            <CompaniesLogo />
            <AuthModal
                isOpen={showAuth}
                onClose={() => setShowAuth(false)}
            />
        </div>
    );
}

export default Home;
